import { render, staticRenderFns } from "./report-record-index.vue?vue&type=template&id=286b8554&scoped=true"
import script from "./report-record-index.vue?vue&type=script&lang=js"
export * from "./report-record-index.vue?vue&type=script&lang=js"
import style0 from "./report-record-index.vue?vue&type=style&index=0&id=286b8554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b8554",
  null
  
)

export default component.exports